<template>
  <v-main>
    <v-container class="fill-height fill-width py-0 my-0">
    <!--<div id="core-view"> -->
      <v-fade-transition mode="out-in">
        <router-view name="nivel2" :key="$route.fullPath ? $route.fullPath : null"  /> <!-- :key="$route.fullPath" -->
      </v-fade-transition>
    <!--</div>-->
    <!--<core-footer v-if="$route.name !== 'Maps'" /> -->
    </v-container>
  </v-main>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'App Sinistros Vue'
    }
  }
}
</script>

<style>
#core-view {
  padding-bottom: 50px;
}

.v-main {
  padding-top: 48px !important;
}

@media (max-width: 650px) {
  .v-content {
    padding-top: 38px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/core/View.vue